import React, { Fragment, memo, useCallback, useMemo, useState } from 'react';
import cn from 'classnames';

import { Icon } from 'components';
import BetslipStakeInput from '../../BetslipStakeInput';
import Combinations from '../../Combinations';
import Error from '../../Error';
import PlaceBet from '../../PlaceBet';
import BetDetails, { TotalType } from '../BetDetails';
import useSystemPart from './useSystemPart';

import arrowLeft from 'assets/svg/arrow-left.svg';
import close from 'assets/svg/close-video.svg';
import './systemPartMob.scss';

interface Props {
    betslipBetId: string;
}

const SystemPartMob: React.FC<Props> = ({ betslipBetId }) => {
    const [isOpen, setIsOpen] = useState(true);
    const toggle = useCallback(() => {
        setIsOpen(i => !i);
    }, []);
    const props = useSystemPart({ betslipBetId });

    const closeBtn = useMemo(
        () => <Icon glyph={close} onClick={toggle} styleName="close-icon" />,
        [toggle]
    );

    if (!props) return null;

    const {
        changeStakeHandler,
        betslipOddsSize,
        finalTotalStake,
        finalTotalWin,
        errorMsgs,
        maxStakeForInput,
        stake,
    } = props;

    return (
        <Fragment>
            <div
                styleName="over-footer"
                className="__app-SystemPartMob-over-footer"
            >
                {errorMsgs.length > 0 && (
                    <div styleName="errors">
                        <Error messages={errorMsgs} />
                    </div>
                )}
                {isOpen && (
                    <div styleName="combinations">
                        <Combinations
                            betslipBetId={betslipBetId}
                            betslipOddsSize={betslipOddsSize}
                            closeBtn={closeBtn}
                        />
                    </div>
                )}
            </div>
            <div styleName="wr-icon" onClick={toggle}>
                <Icon
                    glyph={arrowLeft}
                    styleName={cn('icon', {
                        open: isOpen,
                    })}
                />
            </div>
            <div
                styleName="container"
                className="__app-SystemPartMob-container"
            >
                <BetslipStakeInput
                    maxStake={maxStakeForInput}
                    changeValue={changeStakeHandler}
                    value={stake}
                />
                <BetDetails
                    total={finalTotalStake}
                    totalType={TotalType.stake}
                    totalWin={finalTotalWin}
                />
                <PlaceBet
                    betslipBetId={betslipBetId}
                    totalStake={finalTotalStake}
                />
            </div>
        </Fragment>
    );
};

export default memo(SystemPartMob);
